/**
 * 拉起App
 * @param {String} scheme 拉起App的scheme url
 * @param {String} noAppRedirectUrl  未安装App时跳转的链接
 * @param {Number} 检测时间  检测时间内未拉起App则跳转链接
 */
function launchApp(scheme, noAppRedirectUrl, timeout = 2000) {
    var interval = 20;
    var limit_num = timeout / interval;
    var openTime = +new Date();
    window.location.href = scheme
    var timer = setInterval(function () {
        if (limit_num > 0) {
            limit_num--;
        } else {
            if ((new Date()) - openTime < timeout + 200) {//加了200ms基准误差
                window.location.href = noAppRedirectUrl;
            }
            clearTimeout(timer);
        }
    }, interval);
}

export default launchApp;

